import * as React from 'react';

import {ActionMenu} from 'shells/action-menu/action-menu';
import {EditIcon, TrashIcon, ReportsIcon} from 'shells/icon';

type Props = {
    onEditProductCategory: () => void;
    onDeleteProductCategory: () => void;
    reportLink: string;
};

export function ProductCategoryRowActionMenu(props: Props) {
    const actionMenuRef = React.useRef<HTMLElement | null>(null);

    return (
        <>
            <ActionMenu
                options={[
                    {
                        label: 'Edit',
                        handleSelect: props.onEditProductCategory,
                        icon: <EditIcon size={16} />,
                    },
                    {
                        label: 'Report',
                        handleSelect: () => window.open(props.reportLink, '_blank'),
                        icon: <ReportsIcon size={16} />,
                    },
                    {
                        label: 'Delete',
                        handleSelect: props.onDeleteProductCategory,
                        icon: <TrashIcon size={16} />,
                        variant: 'destructive',
                    },
                ]}
                getRef={(node) => {
                    if (node) {
                        actionMenuRef.current = node;
                    }
                }}
                size='small'
                hasHoverBackground={true}
            />
        </>
    );
}
